import { render, staticRenderFns } from "./SetTags.vue?vue&type=template&id=e0dfbfb0&scoped=true&"
import script from "./SetTags.vue?vue&type=script&lang=js&"
export * from "./SetTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dfbfb0",
  null
  
)

export default component.exports